// extracted by mini-css-extract-plugin
module.exports = {"wideButton":"Screens-styles-wideButton-43ff6454","buttonContainer":"Screens-styles-buttonContainer-28556927","containerButton":"Screens-styles-containerButton-0e4d78cc"};